import { createQueryKeys } from "@lukemorales/query-key-factory";
import {GetNotificationsRequest} from "@/Stub/V1";

export const Notifications = createQueryKeys('notifications', {
    list: (requestParams?: GetNotificationsRequest) => [{ requestParams }],
    unreadCount: null
});
